// Utilities steps (Stake Power, TV and Internet). Public Grid's native offer and enrollment API is not wired
// yet, so the Stake Power values and the "Submit order" action are placeholders taken from the Paper
// design. "Request a call" uses the real MyUtilities order endpoint. Hidden in production builds.
export const UTILITIES_STEPS_ENABLED = process.env.REACT_APP_ENV !== "production";
export const UTILITIES_OFFER = {
  powerCashBack: 50,
  powerCardCashBack: 25,
  homeServicesCashBack: 130,
  homeInternetCashBack: 100,
  rentCashBackPerMonth: 15,
  pricePerKwh: "15.0",
  earlyTerminationFee: 150,
};
export const POWER_LOADING_MS = 1800;
export const POWER_SUBMIT_MS = 900;
export const ACCOUNT_STEPS = UTILITIES_STEPS_ENABLED ? ["Account", "Power", "TV & Internet"] : ["Account"];
export const UTILITY_STEPS = ["Power", "TV & Internet"];

export const formatMoney = (value) => `$${Number(value).toLocaleString("en-US")}`;
